export default __webpack_public_path__ + "static/media/herbalife2.f9ba3eb1.mp4";